// extracted by mini-css-extract-plugin
module.exports = {"audience-portarait-placeholder":"block-placeholder_audience-portarait-placeholder__gm0vL"};